import React from 'react';
import {List, ListItem, FlatButton} from 'material-ui';
import {inject, observer} from 'mobx-react';
import {observable} from 'mobx';
import PinDrop from 'material-ui/svg-icons/maps/pin-drop'

@inject('markerStore')
@observer
export default class RainfallWatchMob extends React.Component {

  standardOrder = ['Mahakali', 'Karnali', 'Babai', 'West Rapti', 'Narayani', 'Bagmati', 'Kamala', 'Koshi', 'Kankai', 'Imja EW Project'];

  @observable intervalIndex = 0;

  changeInterval = (interval) => {
    this.intervalIndex = interval;
  };

  getSortedArray = (items) => {
    items = items.filter(item => item.averages.reduce((acc, i) => i.value === null ? acc += 1 : acc += 0, 0) < 5);
    let sortedArray = [];
    // let dangerItems = items.filter(item => item.status === 'DANGER').sort((a,b) => +a.stationIndex < +b.stationIndex ?-1:1);
    // let warningItems = items.filter(item => item.status === 'WARNING').sort((a,b) => +a.stationIndex < +b.stationIndex ?-1:1);
    let bwlItems = items.filter(item => item.status === 'BELOW WARNING LEVEL').sort((a,b) => +a.stationIndex < +b.stationIndex ?-1:1);
    // let ndItems = items.filter(item => item.status === null);

    // if(dangerItems.length) sortedArray = [ ...sortedArray, ...dangerItems.filter(b => b.stationIndex), ...dangerItems.filter(b => (b.stationIndex === null || b.stationIndex === ''))];
    // if(warningItems.length) sortedArray = [ ...sortedArray, ...warningItems.filter(b => b.stationIndex ), ...warningItems.filter(b => (b.stationIndex === null || b.stationIndex === ''))];
    if(bwlItems.length) sortedArray = [ ...sortedArray, ...bwlItems.filter(b => b.stationIndex), ...bwlItems.filter(b => (b.stationIndex === null || b.stationIndex === ''))];
    // if(ndItems.length) sortedArray = [ ...sortedArray, ...ndItems.sort((a,b) => a.stationIndex && a.name < b.name ?-1:1)];

    return sortedArray;
  };

  getBasinHierarchy = (items) => {
    return this.standardOrder.map(basin => {
      return ({
        name: basin,
        stations: this.getSortedArray(items.filter(item => item.basin && item.basin.indexOf(basin)>-1))
      })
    }).filter(item => item.stations.length > 0);
  };

  getPrioritizedStations = items => {
    items = items.filter(item => item.averages.reduce((acc, i) => i.value === null ? acc += 1 : acc += 0, 0) < 5);
    let sortedArray = [];
    let dangerItems = items.filter(item => item.status === 'DANGER').sort((a,b) => +a.stationIndex < +b.stationIndex ?-1:1);
    let warningItems = items.filter(item => item.status === 'WARNING').sort((a,b) => +a.stationIndex < +b.stationIndex ?-1:1);
    // let bwlItems = items.filter(item => item.status === 'BELOW WARNING LEVEL').sort((a,b) => +a.stationIndex < +b.stationIndex ?-1:1);
    // let ndItems = items.filter(item => item.status === null);

    if(dangerItems.length) sortedArray = [ ...sortedArray, ...dangerItems.filter(b => b.stationIndex), ...dangerItems.filter(b => (b.stationIndex === null || b.stationIndex === ''))];
    if(warningItems.length) sortedArray = [ ...sortedArray, ...warningItems.filter(b => b.stationIndex ), ...warningItems.filter(b => (b.stationIndex === null || b.stationIndex === ''))];
    // if(bwlItems.length) sortedArray = [ ...sortedArray, ...bwlItems.filter(b => b.stationIndex), ...bwlItems.filter(b => (b.stationIndex === null || b.stationIndex === ''))];
    // if(ndItems.length) sortedArray = [ ...sortedArray, ...ndItems.sort((a,b) => a.stationIndex && a.name < b.name ?-1:1)];

    return sortedArray;
  }

  render() {
    const {markerStore} = this.props;
    console.log(this.getBasinHierarchy(markerStore.rainfall_raw));
    let style = {
      minWidth:'30px',
      width:'20%',
      height:'40px',
      lineHeight:'40px'
    };
    let labelStyle={
      padding:'0',
      fontWeight:'normal',
      fontSize:'12px'
    };
    let getColor = status => {
      switch (status) {
        case 'BELOW WARNING LEVEL':
          return 'green';
        case 'WARNING':
          return 'coral';
        case 'DANGER':
          return 'red';
        default:
          return 'black';
      }
    };

    return (
      <div style={{margin:'-10px'}}>
        <div data-spy="affix" data-offset-top="200">
          <div className="inline-it navbar navbar-default navbar-fixed-top" style={{background:'#e9ebee'}}>
            <FlatButton secondary={this.intervalIndex === 0} label={'1 HR'} style={style} labelStyle={labelStyle} onClick={() => this.changeInterval(0)}/>
            <FlatButton secondary={this.intervalIndex === 1} label={'3 HR'} style={style} labelStyle={labelStyle} onClick={() => this.changeInterval(1)}/>
            <FlatButton secondary={this.intervalIndex === 2} label={'6 HR'} style={style} labelStyle={labelStyle} onClick={() => this.changeInterval(2)}/>
            <FlatButton secondary={this.intervalIndex === 3} label={'12 HR'} style={style} labelStyle={labelStyle} onClick={() => this.changeInterval(3)}/>
            <FlatButton secondary={this.intervalIndex === 4} label={'24 HR'} style={style} labelStyle={labelStyle} onClick={() => this.changeInterval(4)}/>
          </div>
        </div>
        <div className="watch_table_caption">Last updated on {markerStore.rainfall_lastUpdateTime}</div>
        <List>{this.getPrioritizedStations(markerStore.rainfall_raw).map(station => (
          <ListItem style={{borderBottom:'1px solid lightgray'}} primaryText={
            <div className="watch-item-mob">
              <div>{station.name} {`(${station.basin}${station.stationIndex ? ', ' + station.stationIndex : ''})`}</div>
              <div style={{color: getColor(station.status), padding: '0px'}}>{station.averages[this.intervalIndex] && station.averages[this.intervalIndex].value !== 'N/A' && station.averages[this.intervalIndex].value !== null? station.averages[this.intervalIndex].value+ ' mm' : '-'}</div>
            </div>
          }/>
        ))}</List>
        <List>{this.getBasinHierarchy(markerStore.rainfall_raw).map(basin => (
          <ListItem style={{fontWeight: 'bold'}}
                    primaryText={basin.name}
                    leftIcon={<PinDrop/>}
                    initiallyOpen={true}
                    primaryTogglesNestedList={true}
                    nestedItems={
                      basin.stations.map(station =>
                        <ListItem style={{borderBottom:'1px solid lightgray'}} primaryText={
                          <div className="watch-item-mob">
                            <div>{station.name} {station.stationIndex ? `(${station.stationIndex})` : ''}</div>
                            <div style={{color: getColor(station.status), padding: '0px'}}>{station.averages[this.intervalIndex] && station.averages[this.intervalIndex].value !== 'N/A' && station.averages[this.intervalIndex].value !== null ? station.averages[this.intervalIndex].value+ ' mm' : '-'}</div>
                          </div>
                        }/>
                      )
                    }
          />
        ))}</List>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Watch/RainfallWatchMob.js